import { HomeApi } from "api-client";
import store from "config/store";
import { Dispatch } from "redux";
import { getAuthConfiguration } from "utils/getAuthConfiguration";

import { ACTIONS } from "./types";

export const getHomePage = () => async (dispatch: Dispatch) => {
    const apiBaseUrl = store.getState().appConfiguration.apiBaseUrl;
    const homeApi = new HomeApi(getAuthConfiguration(apiBaseUrl));
    try {
        dispatch({
            type: ACTIONS.GET_HOME_PAGE_REQUEST,
        });
        const res = await homeApi.getHomePageApiHomeGet();
        dispatch({
            type: ACTIONS.GET_HOME_PAGE_SUCCESS,
            payload: res,
        });
    } catch (e) {
        dispatch({
            type: ACTIONS.GET_HOME_PAGE_FAILURE,
        });
        throw e;
    }
};
